import { Component, computed, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { AccessLevel } from '../../services/asset-service/types';
import {
  tablerBuildings,
  tablerLock,
  tablerQuestionMark,
  tablerWorld,
} from '@ng-icons/tabler-icons';
import { ACCESS_LABEL_MAP } from './constants';

@Component({
  selector: 'asset-access-type',
  template: `
    <ng-icon size="13px" [name]="display().icon" />
    <span>{{ display().label }}</span>
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      font-size: 14px;
      color: #757575;
    }
  `,
  imports: [NgIcon],
  providers: [provideIcons({ tablerLock, tablerWorld, tablerBuildings, tablerQuestionMark })],
})
export class AssetAccessType {
  accessLevel = input.required<AccessLevel>();

  display = computed(() => {
    return {
      icon: ACCESS_LABEL_MAP[this.accessLevel()].icon ?? 'tablerQuestionMark',
      label: this.accessLevel(),
    };
  });
}
